export const stats = [
  { value: '9', label: 'Volumes Complets' },
  { value: '600+', label: 'Pages de Ressources' },
  { value: '300+', label: 'Unités Didactiques' },
  { value: '100%', label: 'Prêt pour la Classe' },
]

export const beforeItems = [
  'Des dimanches entiers à planifier.',
  'Des fiches trouvées en ligne qui ne collent pas à votre classe.',
  'Aucune progression claire d’une année à l’autre.',
  'Des évaluations et corrigés à créer vous-même.',
]

export const afterItems = [
  'Une année entière organisée pour chaque niveau.',
  'Leçons et fiches prêtes à imprimer ou projeter.',
  'Une progression logique du CP à la 3ème.',
  'Évaluations et corrigés inclus.',
]

export const recognizeItems = [
  'Vous n’avez plus le temps de préparer des cours vraiment engageants.',
  'Vous voyez vos élèves s’ennuyer avec les mêmes activités répétitives.',
  'Gérer des niveaux différents dans une même classe vous semble une mission impossible.',
  'Vous enseignez la musique en dehors de votre spécialité et vous avez peur de vous tromper.',
  'Vous ne trouvez rien qui fonctionne vraiment aussi bien pour les plus jeunes que pour les collégiens.',
]

export type Volume = {
  number: number
  title: string
  text: string
  level: string
  accent: string
}

export const primaryVolumes: Volume[] = [
  {
    number: 1,
    title: 'Exploration des Sons',
    text: 'Découverte du son, du silence et premiers pas rythmiques.',
    level: 'CP',
    accent: '#e2483d',
  },
  {
    number: 2,
    title: 'Le Rythme en Mouvement',
    text: 'La pulsation et le corps comme premier instrument.',
    level: 'CE1',
    accent: '#f0913f',
  },
  {
    number: 3,
    title: 'L’Univers des Instruments',
    text: 'Reconnaissance des instruments, familles et lecture musicale facilitée.',
    level: 'CE2',
    accent: '#2f8fd6',
  },
  {
    number: 4,
    title: 'Voyage à travers les Époques',
    text: 'Écoute active et découverte des grands compositeurs.',
    level: 'CM1',
    accent: '#3fa96b',
  },
  {
    number: 5,
    title: 'Musiques du Monde',
    text: 'Jazz, musiques du monde, chant, pratique collective et exploration sonore.',
    level: 'CM2',
    accent: '#12988a',
  },
]

export const secondaryVolumes: Volume[] = [
  {
    number: 6,
    title: 'Le Langage Musical',
    text: 'Théorie visuelle, solfège, rythme, mélodie et analyse musicale.',
    level: '6ème',
    accent: '#16388f',
  },
  {
    number: 7,
    title: 'Musique et Image',
    text: 'Musique de film, publicité, jeux vidéo et émotions.',
    level: '5ème',
    accent: '#7e5bc4',
  },
  {
    number: 8,
    title: 'L’Évolution des Styles',
    text: 'Du Rock au Hip-Hop, identité musicale et création numérique.',
    level: '4ème',
    accent: '#0d7a6f',
  },
  {
    number: 9,
    title: 'Création et Technologie',
    text: 'IA, streaming, composition et préparation complète aux projets de fin de cycle.',
    level: '3ème',
    accent: '#b8456f',
  },
]

export const bonuses = [
  {
    title: 'Kit « Première Leçon Parfaite »',
    text: 'Captez l’attention des élèves dès les 60 premières secondes et installez votre autorité avec joie.',
    value: '39€',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/39c49ad2-6a48-4054-8084-5aa078cd21a7.jpg',
  },
  {
    title: 'Banque de Cues « L’Enseignant qui Inspire »',
    text: 'Les mots exacts à utiliser pour expliquer le rythme et l’harmonie afin que tout le monde comprenne du premier coup.',
    value: '37€',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/d2f8857f-3516-4f30-96e2-753939bc09a5.jpg',
  },
  {
    title: 'Système « Progrès Visible »',
    text: 'Modèles d’autoévaluation et certificats. Quand les parents voient le progrès, votre valeur double.',
    value: '39€',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/246b8dbf-ad33-4eee-81ed-5ef594b603b9.jpg',
  },
  {
    title: 'Guide « Classes de Groupe Sans Chaos »',
    text: 'La méthode pour gérer 25 instruments sans perdre le contrôle de la classe.',
    value: '35€',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/16eed74f-35f0-4ab5-8495-cda9328fc5b2.jpg',
  },
  {
    title: 'Kit « Anti-Absence et Motivation »',
    text: 'Stratégies psychologiques pour garder les élèves motivés et réduire l’absentéisme.',
    value: '35€',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/310591eb-8573-4f25-875b-ad1f505cea5f.jpg',
  },
]

export type MaterialSlide = {
  src: string
  title: string
  label: string
  text: string
}

export const materialSlides: MaterialSlide[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/e3J3MHiyzvdGVibmRQVbPn/Captura_de_pantalla_2026-09-11_a_las_7.31.24_p.webp',
    title: 'Les Familles d’Instruments',
    label: 'Fiche enseignant · CP',
    text: 'Une séance de 45 minutes minutée pas à pas : percussions, cordes, vents et claviers, avec le geste à mimer pour chaque famille.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vDEG7dqxkVmPUkfihG4Ycb/Captura_de_pantalla_2026-09-11_a_las_7.33.12_p.webp',
    title: 'Patterns Mixtes — Noire, Croches et Silence',
    label: 'Rythme corporel',
    text: 'Des rythmes à frapper avec les mains et les pieds pour travailler la pulsation, le silence actif et la coordination.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kHUokNCfX1NRKgu9BmjzzM/Captura_de_pantalla_2026-09-11_a_las_7.33.46_p.webp',
    title: 'Do Ré Mi Fa Sol — Les Notes sur la Portée',
    label: 'Fiche élève · CE2',
    text: 'Une couleur par note et quatre exercices progressifs pour lire et placer les notes sur la portée.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/t5UkpJX3vvNdaNoH5NVDHb/Captura_de_pantalla_2026-09-11_a_las_7.34.38_p.webp',
    title: 'Rythme Avancé et Métrique',
    label: 'Fiche élève',
    text: 'Mesures 2/4, 3/4, 4/4 et 6/8, noire pointée et triolets, avec composition, mouvement et auto-évaluation.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3WQ5riQcrM94Wdt7a9fvVP/Captura_de_pantalla_2026-09-11_a_las_7.35.28_p.webp',
    title: 'Musique de Jeux Vidéo',
    label: 'Collège · Ludomusicologie',
    text: 'De Pong à The Last of Us : l’histoire, les fonctions clés et les grands compositeurs de la musique de jeux vidéo.',
  },
]

export const offerRows = [
  { label: 'Musique Prête™ (9 Volumes)', value: '197€' },
  { label: '5 Bonus Stratégiques', value: '185€' },
]

export const offerPricing = {
  totalValue: '382€',
  price: '19€',
}

export const testimonials = [
  {
    quote:
      'C’est exactement ce dont j’avais besoin. La planification annuelle à elle seule vaut le prix. J’ai enfin retrouvé mes dimanches.',
    name: 'Sara M.',
    role: 'Enseignante en École Primaire',
  },
  {
    quote:
      'Les fiches sont magnifiques et les élèves du collège ne s’ennuient pas. Un matériel d’une qualité rare.',
    name: 'Giacomo T.',
    role: 'Professeur de Musique',
  },
]

export const faqs = [
  {
    q: 'Dans quel format sont les documents ?',
    a: 'Ce sont des PDF haute résolution prêts à être imprimés ou projetés en classe.',
  },
  {
    q: 'Est-ce adapté si je n’ai pas de solides bases musicales ?',
    a: 'Oui, tout est conçu pour guider l’enseignant pas à pas.',
  },
  {
    q: 'Comment vais-je recevoir le matériel ?',
    a: 'Par email, immédiatement après le paiement.',
  },
  {
    q: 'Puis-je l’utiliser sur tablette ?',
    a: 'Oui, les fichiers sont compatibles avec tous les appareils numériques.',
  },
  {
    q: 'Dois-je payer un abonnement mensuel ?',
    a: 'Non. C’est un paiement unique et l’accès au matériel vous appartient pour toujours.',
  },
  {
    q: 'Et si cela ne me convient pas ?',
    a: 'Vous avez 30 jours de garantie : nous vous remboursons intégralement et vous gardez les 5 bonus.',
  },
]

export const heroGuarantees = [
  'Téléchargement numérique instantané',
  'PDF prêts pour l’impression',
  'Paiement unique',
]

export const footerLinks = [
  'Conditions Générales',
  'Politique de Confidentialité',
  'Contact',
]
